import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import SiteFooter from "@/components/pivotbox/SiteFooter";
import { brandAssets, legalPages } from "@/components/pivotbox/siteContent";

export default function LegalDocumentPage({ pageKey }) {
  const page = legalPages[pageKey];

  return (
    <div className="pivotbox-shell" data-testid={`legal-page-${pageKey}`}>
      <header className="site-header" data-testid={`legal-page-${pageKey}-header`}>
        <div className="pivotbox-container site-header__inner">
          <Link className="site-logo" data-testid={`legal-page-${pageKey}-logo-link`} to="/">
            <span className="site-logo__mark" data-testid={`legal-page-${pageKey}-logo-mark`}>
              <img alt="Pivotbox brand mark" className="site-logo__mark-image" data-testid={`legal-page-${pageKey}-logo-mark-image`} src={brandAssets.mark} />
            </span>
            <span className="site-logo__wordmark" data-testid={`legal-page-${pageKey}-logo-text`}>
              <img alt="The Pivotbox wordmark" className="site-logo__wordmark-image" data-testid={`legal-page-${pageKey}-logo-wordmark-image`} src={brandAssets.wordmark} />
            </span>
          </Link>

          <Link className="pivotbox-button pivotbox-button--ghost" data-testid={`legal-page-${pageKey}-back-link`} to="/">
            <ArrowLeft size={18} />
            Back to home
          </Link>
        </div>
      </header>

      <main className="legal-shell">
        <div className="pivotbox-container">
          <section className="legal-hero" data-testid={`legal-page-${pageKey}-hero`}>
            <span className="section-label" data-testid={`legal-page-${pageKey}-eyebrow`}>
              Pivotbox policies
            </span>
            <h1 className="section-title section-title--medium" data-testid={`legal-page-${pageKey}-title`}>
              {page.title}
            </h1>
            <p className="section-description" data-testid={`legal-page-${pageKey}-intro`}>
              {page.intro}
            </p>
            {page.updatedAt && (
              <p className="body-copy" data-testid={`legal-page-${pageKey}-updated-at`}>
                {page.updatedAt}
              </p>
            )}
          </section>

          <section className="legal-panel" data-testid={`legal-page-${pageKey}-content`}>
            {page.sections.map((section, index) => (
              <div className="legal-section" data-testid={`legal-page-${pageKey}-section-${index + 1}`} key={section.heading}>
                <h2 data-testid={`legal-page-${pageKey}-section-${index + 1}-heading`}>{section.heading}</h2>
                <div className="legal-body" data-testid={`legal-page-${pageKey}-section-${index + 1}-body`}>
                  {section.body.length > 1 ? (
                    <ul data-testid={`legal-page-${pageKey}-section-${index + 1}-list`}>
                      {section.body.map((item, itemIndex) => (
                        <li data-testid={`legal-page-${pageKey}-section-${index + 1}-item-${itemIndex + 1}`} key={item}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p data-testid={`legal-page-${pageKey}-section-${index + 1}-paragraph`}>{section.body[0]}</p>
                  )}
                </div>
              </div>
            ))}
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}